import { OktaAuth } from '@okta/okta-auth-js';

export const OKTA_CONFIG = new OktaAuth({
    issuer: 'https://55places.okta.com/',
    clientId: '0oa8t26dgmb0raFK0697',
    scopes: ['openid', 'profile', 'email', 'groups'],
    redirectUri: window.location.origin + '/login/callback'
    });